import en from './en';

export const commonTranslations: NamespaceTranslations<keyof typeof en> = {
  en,
};
